import "./CadastroAccessPoints.css";
import { useEffect, useState } from "react";
import FormAccessPoints from "../FormAccessPoints/FormAccessPoints";
import { useListManager } from "../../../contexts/list.manager";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import AccessModuleService from "../../../services/AccessModuleService";

const CadastroAccessPoints = () => {
	const { accessPointId } = useParams();
	const { state } = useLocation();
	const { lineSelected } = useListManager();
	const [accessPoint, setAccessPoint] = useState(lineSelected);
	const [formMode, setFormMode] = useState("");

	async function loadAccessPoint(uuid) {
		const response = await AccessModuleService.getOneUuid(uuid);
		if (response.data) {
			setAccessPoint(response.data);
		}
	}

	useEffect(() => {
		setFormMode(accessPointId || lineSelected ? "edicao" : "cadastro");

		if (accessPoint) {
			setAccessPoint(state);
			return;
		}

		if (accessPointId) {
			loadAccessPoint(accessPointId);
		}
	}, [lineSelected, state, accessPointId]);

	return (
		<CadastroContainer>
			<FormAccessPoints
				accessPoint={accessPoint}
				formMode={formMode}
				accessType={state?.accessType || accessPoint?.type}
			/>
		</CadastroContainer>
	);
};

export default CadastroAccessPoints;
